export const defaultDemoConfig = {
    layout: {
        cardLayout: 'gridFour',
        filterLayout: 'filterSide'
    },
    pagination: {
        type: 'pagination',
        itemsPerPage: 24
    },
    features: {
        searchBar: true,
        filters: true,
        sorting: true,
        productCount: true
    },
    visual: {
        cardStyle: 'default',
        spacing: 'normal'
    },
    search: {
        provider: 'mock',
        mockPlatform: 'algolia',
        apiKeys: {}
    }
};
export const CARD_LAYOUT_OPTIONS = [
    { value: 'gridTwo', label: '2 Columns' },
    { value: 'gridFour', label: '4 Columns' },
    { value: 'list', label: 'List View' }
];
export const FILTER_LAYOUT_OPTIONS = [
    { value: 'filterTop', label: 'Top Bar' },
    { value: 'filterSide', label: 'Sidebar' },
    { value: 'filterDrawer', label: 'Drawer' }
];
export const PAGINATION_TYPE_OPTIONS = [
    { value: 'none', label: 'No Pagination' },
    { value: 'pagination', label: 'Traditional Pagination' },
    { value: 'infiniteAuto', label: 'Infinite Scroll (Auto)' },
    { value: 'infiniteButton', label: 'Infinite Scroll (Button)' }
];
export const ITEMS_PER_PAGE_OPTIONS = [
    { value: 12, label: '12 items' },
    { value: 24, label: '24 items' },
    { value: 36, label: '36 items' },
    { value: 48, label: '48 items' }
];
export const CARD_STYLE_OPTIONS = [
    { value: 'default', label: 'Default' },
    { value: 'compact', label: 'Compact' },
    { value: 'detailed', label: 'Detailed' }
];
export const SPACING_OPTIONS = [
    { value: 'compact', label: 'Compact' },
    { value: 'normal', label: 'Normal' },
    { value: 'spacious', label: 'Spacious' }
];
